import ViewFormTemplateContainer from "./ViewFormTemplate.container";

export default ViewFormTemplateContainer;
